/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/components/progress-bar.js":
/*!*******************************************!*\
  !*** ./src/js/components/progress-bar.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ProgressBar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ProgressBar, _HTMLElement);
  var _super = _createSuper(ProgressBar);
  function ProgressBar() {
    var _this$dataset$success;
    var _this;
    _classCallCheck(this, ProgressBar);
    _this = _super.call(this);
    _this.promotions = [];
    _this.max = 0;
    _this.cartTotal = Number.parseInt(_this.dataset.cartTotal) / 100;
    _this.bar = _this.querySelector("[data-bar]");
    _this.message = _this.querySelector("[data-message]");
    _this.enableSteps = _this.dataset.enableSteps;
    _this.badgesSection = _this.querySelector("[data-badges]");
    _this.proportion = _this.dataset.proportion;
    _this.successMessage = (_this$dataset$success = _this.dataset.successMessage) === null || _this$dataset$success === void 0 ? void 0 : _this$dataset$success.toLowerCase().replace('[', '<span style="color: #C94A18;">').replace(']', '</span>');
    // if (this.dataset.shipscoutEnabled === "true") {
    //   this.getShipScoutPromotions(); 
    // } else {
    _this.getThemePromotions();
    // }
    _this.buildProgressBar();
    return _this;
  }
  _createClass(ProgressBar, [{
    key: "buildProgressBar",
    value: function buildProgressBar() {
      console.log('building progress bar...');
      if (this.promotions.length === 0) return;
      this.sortAndSetActivePromotion();
      this.createStepsAndBadges();
      this.createProgressBar();
      this.displayMessage();
    }
  }, {
    key: "getThemePromotions",
    value: function getThemePromotions() {
      var promotions = this.querySelectorAll("[data-promotion]");
      // Create a Promotions Array of all the arrays.
      var _iterator = _createForOfIteratorHelper(promotions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var promotion = _step.value;
          var threshold = Number.parseInt(promotion.dataset.threshold);
          this.promotions.push({
            title: promotion.dataset.title,
            threshold: Shopify.currency.active != null ? Math.ceil(threshold * Shopify.currency.rate) : threshold,
            messageText: promotion.dataset.messageText,
            icon: promotion.dataset.icon
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    // getShipScoutPromotions() {
    //   if (window.shipscoutTestObject == null) return;
    //   this.promotions.push(window.shipscoutTestObject);
    // }
  }, {
    key: "sortAndSetActivePromotion",
    value: function sortAndSetActivePromotion() {
      var _this2 = this;
      // Sort Promotions Array in ascending order based on thresholds.
      function compare(a, b) {
        if (a.threshold < b.threshold) {
          return -1;
        }
        if (a.threshold > b.threshold) {
          return 1;
        }
        return 0;
      }
      this.promotions.sort(compare);

      // Find max threshold, find current promotion.
      this.promotions.forEach(function (promotion) {
        if (promotion.threshold <= _this2.cartTotal) {
          promotion.active = true;
        } else {
          promotion.active = false;
          if (_this2.currentPromotion == null) {
            _this2.currentPromotion = promotion;
          }
        }
        if (_this2.max < promotion.threshold) {
          _this2.max = promotion.threshold;
        }
      });
    }
  }, {
    key: "displayMessage",
    value: function displayMessage() {
      var currencyMap = {
        CAD: "$",
        USD: "$",
        AUD: "$",
        BRL: "R$",
        EUR: "€",
        HKD: "$",
        ILS: "₪",
        JPY: "¥",
        MXN: "$",
        NZD: "$",
        NOK: "kr",
        SGD: "$",
        KRW: "₩",
        GBP: "£"
      };
      if (this.currentPromotion != null) {
        var _currencyMap$Shopify$;
        var amountLeft = Math.ceil(this.currentPromotion.threshold - this.cartTotal);
        var currencySymbol = (_currencyMap$Shopify$ = currencyMap[Shopify.currency.active]) !== null && _currencyMap$Shopify$ !== void 0 ? _currencyMap$Shopify$ : Shopify.currency.active;
        var messageText = this.currentPromotion.messageText.toLowerCase().replace('[', '<span style="color: #C94A18;">').replace(']', '</span>').replace('{amount-left}', "<span class=\"currency-symbol\">".concat(currencySymbol, "</span>").concat(amountLeft));
        this.message.innerHTML = messageText;
      } else {
        // let promotionSuccessMessage = promotion.successMessage.toLowerCase().replace('[', '<span style="color: #C94A18;">').replace(']', '</span>');
        // if (promotionSuccessMessage == null) {
        //   this.message.innerHTML = promotionSuccessMessage;
        // } else {
        this.message.innerHTML = this.successMessage;
        // }
      }
    }
  }, {
    key: "createStepsAndBadges",
    value: function createStepsAndBadges() {
      var _this3 = this;
      var fragment = document.createDocumentFragment();
      this.promotions.forEach(function (promotion, i) {
        if (_this3.enableSteps == 'true') {
          var step = document.createElement("div");
          step.classList.add("progress-bar__step");
          step.classList.add("progress-bar__step--".concat(promotion.icon));
          if (promotion.active) step.classList.add("progress-bar__step--active");
          step.innerHTML = "<svg\n  class=\"icon icon-checkmark\"\n  aria-hidden=\"true\"\n  focusable=\"false\"\n  viewBox=\"0 0 9 7\" \n  fill=\"none\" \n  xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M2.98571 6.29881L0 3.3131L0.746429 2.56667L2.98571 4.80595L7.79167 0L8.5381 0.746429L2.98571 6.29881Z\" fill=\"currentColor\"/>\n</svg>\n<svg class=\"icon icon-gift\" aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 13 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M1.077 13.3205V6.064H0V2.58983H3.4475C3.3535 2.48128 3.28961 2.359 3.25583 2.223C3.22206 2.08711 3.20517 1.94439 3.20517 1.79483C3.20517 1.29628 3.37967 0.8725 3.72867 0.5235C4.07767 0.1745 4.50144 0 5 0C5.25556 0 5.49233 0.0536105 5.71033 0.160833C5.92822 0.268166 6.12306 0.411555 6.29483 0.590999C6.46661 0.404666 6.6615 0.259611 6.8795 0.155833C7.09739 0.051944 7.33411 0 7.58967 0C8.08833 0 8.51217 0.1745 8.86117 0.5235C9.21017 0.8725 9.38467 1.29628 9.38467 1.79483C9.38467 1.94272 9.36606 2.08333 9.32883 2.21667C9.29161 2.35 9.22944 2.47439 9.14233 2.58983H12.6667V6.064H11.5897V13.3205H1.077ZM7.025 1.2285C6.87156 1.38083 6.79483 1.56961 6.79483 1.79483C6.79483 2.02006 6.871 2.20883 7.02333 2.36117C7.17567 2.51361 7.36445 2.58983 7.58967 2.58983C7.81489 2.58983 8.00372 2.51361 8.15617 2.36117C8.3085 2.20883 8.38467 2.02006 8.38467 1.79483C8.38467 1.56961 8.30795 1.38083 8.1545 1.2285C8.00106 1.07617 7.81278 1 7.58967 1C7.36667 1 7.17844 1.07617 7.025 1.2285ZM4.20517 1.79483C4.20517 2.02006 4.28183 2.20883 4.43517 2.36117C4.58861 2.51361 4.77689 2.58983 5 2.58983C5.22311 2.58983 5.41139 2.51361 5.56483 2.36117C5.71817 2.20883 5.79483 2.02006 5.79483 1.79483C5.79483 1.56961 5.71867 1.38083 5.56633 1.2285C5.414 1.07617 5.22522 1 5 1C4.77478 1 4.586 1.07617 4.43367 1.2285C4.28133 1.38083 4.20517 1.56961 4.20517 1.79483ZM1 3.58967V5.06417H5.83333V3.58967H1ZM5.83333 12.3205V6.064H2.07683V12.3205H5.83333ZM6.83333 12.3205H10.5898V6.064H6.83333V12.3205ZM11.6667 5.06417V3.58967H6.83333V5.06417H11.6667Z\" fill=\"currentColor\"/>\n</svg>\n<svg class=\"icon icon-truck\" aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 18 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_315_834)\">\n<path d=\"M12.2131 8.84914C12.0522 8.84914 11.922 8.7189 11.922 8.55806V0.943007H3.27546C3.11461 0.943007 2.98438 0.812768 2.98438 0.651923C2.98438 0.491079 3.11461 0.36084 3.27546 0.36084H12.1512C12.3459 0.36084 12.5042 0.51908 12.5042 0.713787V8.55838C12.5042 8.71923 12.3739 8.84947 12.2131 8.84947V8.84914Z\" fill=\"#84744E\"/>\n<path d=\"M12.1512 0.943007H12.1515M12.2131 8.84914C12.0522 8.84914 11.922 8.7189 11.922 8.55806V0.943007H3.27546C3.11461 0.943007 2.98438 0.812768 2.98438 0.651923C2.98438 0.491079 3.11461 0.36084 3.27546 0.36084H12.1512C12.3459 0.36084 12.5042 0.51908 12.5042 0.713787V8.55838C12.5042 8.71923 12.3739 8.84947 12.2131 8.84947V8.84914Z\" stroke=\"#84744E\"/>\n<path d=\"M5.3163 8.8492H3.27546C3.11461 8.8492 2.98438 8.71896 2.98438 8.55811C2.98438 8.39727 3.11461 8.26703 3.27546 8.26703H5.3163C5.47714 8.26703 5.60738 8.39727 5.60738 8.55811C5.60738 8.71896 5.47714 8.8492 5.3163 8.8492Z\" fill=\"#84744E\" stroke=\"#84744E\"/>\n<path d=\"M13.4189 8.8492H8.22077C8.05993 8.8492 7.92969 8.71896 7.92969 8.55811C7.92969 8.39727 8.05993 8.26703 8.22077 8.26703H13.4189C13.5798 8.26703 13.71 8.39727 13.71 8.55811C13.71 8.71896 13.5798 8.8492 13.4189 8.8492Z\" fill=\"#84744E\" stroke=\"#84744E\"/>\n<path d=\"M16.8989 8.84917H16.2923C16.1315 8.84917 16.0013 8.71893 16.0013 8.55809C16.0013 8.39724 16.1315 8.26701 16.2923 8.26701H16.8989C17.1155 8.26701 17.2916 8.09086 17.2916 7.87434V5.48348C17.2916 5.42748 17.276 5.37278 17.2467 5.32557L15.1795 1.99504H12.2579C12.097 1.99504 11.9668 1.8648 11.9668 1.70396C11.9668 1.54311 12.097 1.41287 12.2579 1.41287H15.2377C15.4041 1.41287 15.5555 1.4972 15.6434 1.63851L17.7416 5.01853C17.8282 5.15821 17.8741 5.31905 17.8741 5.48381V7.87466C17.8741 8.41222 17.4368 8.84982 16.8989 8.84982V8.84917Z\" fill=\"#84744E\"/>\n<path d=\"M15.2377 1.99504H15.2381M16.8989 8.84917H16.2923C16.1315 8.84917 16.0013 8.71893 16.0013 8.55809C16.0013 8.39724 16.1315 8.26701 16.2923 8.26701H16.8989C17.1155 8.26701 17.2916 8.09086 17.2916 7.87434V5.48348C17.2916 5.42748 17.276 5.37278 17.2467 5.32557L15.1795 1.99504H12.2579C12.097 1.99504 11.9668 1.8648 11.9668 1.70396C11.9668 1.54311 12.097 1.41287 12.2579 1.41287H15.2377C15.4041 1.41287 15.5555 1.4972 15.6434 1.63851L17.7416 5.01853C17.8282 5.15821 17.8741 5.31905 17.8741 5.48381V7.87466C17.8741 8.41222 17.4368 8.84982 16.8989 8.84982V8.84917Z\" stroke=\"#84744E\"/>\n<path d=\"M14.8552 10.3107C13.9022 10.3107 13.127 9.53547 13.127 8.58245C13.127 7.62943 13.9022 6.85419 14.8552 6.85419C15.8082 6.85419 16.5835 7.62943 16.5835 8.58245C16.5835 9.53547 15.8082 10.3107 14.8552 10.3107ZM14.8552 7.43668C14.2232 7.43668 13.7094 7.9508 13.7094 8.58245C13.7094 9.21411 14.2236 9.72823 14.8552 9.72823C15.4869 9.72823 16.001 9.21411 16.001 8.58245C16.001 7.9508 15.4869 7.43668 14.8552 7.43668Z\" fill=\"#84744E\" stroke=\"#84744E\"/>\n<path d=\"M6.78295 10.3107C5.82993 10.3107 5.05469 9.53547 5.05469 8.58245C5.05469 7.62943 5.82993 6.85419 6.78295 6.85419C7.73598 6.85419 8.51122 7.62943 8.51122 8.58245C8.51122 9.53547 7.73598 10.3107 6.78295 10.3107ZM6.78295 7.43668C6.15097 7.43668 5.63718 7.9508 5.63718 8.58245C5.63718 9.21411 6.1513 9.72823 6.78295 9.72823C7.41461 9.72823 7.92873 9.21411 7.92873 8.58245C7.92873 7.9508 7.41461 7.43668 6.78295 7.43668Z\" fill=\"#84744E\" stroke=\"#84744E\"/>\n<path d=\"M17.4976 5.58875H14.6574C14.4227 5.58875 14.2218 5.42107 14.1798 5.19022L13.8213 3.17022C13.7988 3.04617 13.8323 2.91821 13.9141 2.82021C13.9958 2.7222 14.1156 2.6662 14.2432 2.6662H15.9458C16.1066 2.6662 16.2369 2.79644 16.2369 2.95728C16.2369 3.11813 16.1066 3.24837 15.9458 3.24837H14.4269L14.7388 5.00626H17.4979C17.6588 5.00626 17.789 5.1365 17.789 5.29734C17.789 5.45819 17.6588 5.58843 17.4979 5.58843L17.4976 5.58875ZM14.3943 3.06701V3.06831C14.3943 3.06831 14.3943 3.06733 14.3943 3.06701Z\" fill=\"#84744E\" stroke=\"#84744E\"/>\n<path d=\"M3.26582 2.37166H1.33796C1.17711 2.37166 1.04688 2.24142 1.04688 2.08057C1.04688 1.91973 1.17711 1.78949 1.33796 1.78949H3.26582C3.42666 1.78949 3.5569 1.91973 3.5569 2.08057C3.5569 2.24142 3.42666 2.37166 3.26582 2.37166Z\" fill=\"#84744E\" stroke=\"#84744E\"/>\n<path d=\"M4.0676 4.05476H2.01179C1.85094 4.05476 1.7207 3.92452 1.7207 3.76368C1.7207 3.60283 1.85094 3.4726 2.01179 3.4726H4.0676C4.22845 3.4726 4.35869 3.60283 4.35869 3.76368C4.35869 3.92452 4.22845 4.05476 4.0676 4.05476Z\" fill=\"#84744E\" stroke=\"#84744E\"/>\n<path d=\"M4.08598 7.42055H1.39069C1.22985 7.42055 1.09961 7.29031 1.09961 7.12946C1.09961 6.96862 1.22985 6.83838 1.39069 6.83838H4.08598C4.24683 6.83838 4.37706 6.96862 4.37706 7.12946C4.37706 7.29031 4.24683 7.42055 4.08598 7.42055Z\" fill=\"#84744E\" stroke=\"#84744E\"/>\n<path d=\"M3.14784 5.73744H0.393622C0.232778 5.73744 0.102539 5.6072 0.102539 5.44636C0.102539 5.28551 0.232778 5.15527 0.393622 5.15527H3.14784C3.30869 5.15527 3.43893 5.28551 3.43893 5.44636C3.43893 5.6072 3.30869 5.73744 3.14784 5.73744Z\" fill=\"#84744E\" stroke=\"#84744E\"/>\n<path d=\"M6.11719 4.20741C6.11719 5.28872 6.99369 6.16523 8.075 6.16523C9.15631 6.16523 10.0328 5.28872 10.0328 4.20741V3.71804H8.075V3.84926C8.075 4.31747 8.45464 4.69679 8.92253 4.69679C8.75029 4.99471 8.42567 5.19332 8.05514 5.18616C7.51725 5.17541 7.09333 4.74042 7.09626 4.20221C7.09919 3.66399 7.53614 3.22867 8.075 3.22867H10.0328V2.2496H8.075C6.99369 2.2496 6.11719 3.12611 6.11719 4.20741Z\" fill=\"#84744E\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_315_834\">\n<rect width=\"18\" height=\"10.5652\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";
          var left = _this3.proportion === "equidistant" ? (i + 1) / _this3.promotions.length * 100 : promotion.threshold / _this3.max * 100;
          step.style.left = "".concat(left, "%");
          step.style.transform = "translate(-50%, -50%)";

          // const promotionBadge = document.createElement("div");
          // promotionBadge.classList.add("progress-bar__badge");
          // if (promotion.active)
          //   promotionBadge.classList.add("progress-bar__badge--active");
          // const promotionBadgeTitle = document.createElement("div");
          // promotionBadgeTitle.classList.add("progress-bar__badge-title");
          // promotionBadgeTitle.innerText = promotion.title;
          // promotionBadge.appendChild(promotionBadgeTitle);
          // step.appendChild(promotionBadge);

          _this3.bar.append(step);
        }

        // if (this.badgesSection != null) {
        //   const promotionBadge = document.createElement("div");
        //   promotionBadge.classList.add("progress-bar__badge");
        //   promotionBadge.style.width = `${100 / this.promotions.length}%`;
        //   if (promotion.active)
        //     promotionBadge.classList.add("progress-bar__badge--active");
        //   const promotionBadgeTitle = document.createElement("div");
        //   promotionBadgeTitle.classList.add("progress-bar__badge-title");
        //   promotionBadgeTitle.innerText = promotion.title;
        //   promotionBadge.appendChild(promotionBadgeTitle);
        //   fragment.appendChild(promotionBadge);
        // }
      });

      if (this.badgesSection != null) {
        this.badgesSection.innerHTML = '';
        this.badgesSection.appendChild(fragment);
      }
    }
  }, {
    key: "createProgressBar",
    value: function createProgressBar() {
      var innerProgressBar = document.querySelector('.progress-bar__inner-bar') || document.createElement("div");
      innerProgressBar.classList.add("progress-bar__inner-bar");
      var width = 0;
      if (this.proportion === "equidistant") {
        var currentThreshold = 0;
        for (var i = 0; i < this.promotions.length; i++) {
          if (this.promotions[i].active) {
            width += 100 / this.promotions.length;
            currentThreshold = this.promotions[i].threshold;
          } else {
            width += (this.cartTotal - currentThreshold) / (this.promotions[i].threshold - currentThreshold) * (100 / this.promotions.length);
            break;
          }
        }
      } else {
        width = this.cartTotal / this.max * 100;
      }
      innerProgressBar.style.width = "".concat(width >= 100 ? 100 : width, "%");
      this.bar.append(innerProgressBar);
    }
  }]);
  return ProgressBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("progress-bar", ProgressBar);

/***/ }),

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_progress_bar_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./components/progress-bar.js */ "./src/js/components/progress-bar.js");
/* harmony import */ var _components_progress_bar_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_components_progress_bar_js__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// Import free gift calculator component

var ProductItemCard = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ProductItemCard, _HTMLElement);
  var _super = _createSuper(ProductItemCard);
  function ProductItemCard() {
    var _this;
    _classCallCheck(this, ProductItemCard);
    _this = _super.call(this);
    _this.selectedVariant = _this.dataset.variantId;
    _this.variantsImages = _this.querySelectorAll('.product-variants-image img');
    _this.productOptions = JSON.parse(_this.dataset.productOptions).map(function (option) {
      return option.name;
    });
    _this.product = JSON.parse(_this.dataset.productVariants);
    _this.priceWrapper = _this.querySelector(".grid-product__price");
    //here i want to set some variants available false just for testing i want to make them random
    // this.product.variants.forEach(variant => {
    //     variant.available = Math.random() >= 0.5;
    // });
    return _this;
  }
  _createClass(ProductItemCard, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$querySelector,
        _this2 = this;
      (_this$querySelector = this.querySelector(".atc-btn")) === null || _this$querySelector === void 0 ? void 0 : _this$querySelector.addEventListener("click", function () {
        var qty = 1;
        _this2.addToCartGrid(qty);
      });
      this.querySelectorAll(".trigger-update-variant").forEach(function (el) {
        el.addEventListener("click", function () {
          _this2.getVariantBySelectedOption(el.dataset.optionName, el.dataset.optionValue);
          _this2.checkDisablitiyButtons(el.dataset.optionName, el.dataset.optionValue);
          _this2.updatePriceCurrentVariant();
          _this2.updateBuyButtonState();
          // //update image
          var imgElement = _this2.querySelector(".grid-product__image-mask img");
          _this2.variantsImages.forEach(function (image) {
            if (image.dataset.variantId === _this2.selectedVariant.toString()) {
              console.log(image.dataset.variantId, _this2.selectedVariant);
              imgElement.setAttribute("src", image.dataset.variantImage);
              imgElement.setAttribute("srcset", image.dataset.variantImageSrcset);
            }
          });
        });
      });
      //select first avaialble option
      var firstAvailableVariant = this.product.variants.find(function (variant) {
        return variant.available;
      });
      if (firstAvailableVariant) {
        this.selectedVariant = firstAvailableVariant.id;
        this.selectVariantSelectionByOption(firstAvailableVariant.options);
        this.checkDisablitiyButtons(this.productOptions[0], firstAvailableVariant.options[0]);
        this.updatePriceCurrentVariant();
        this.updateBuyButtonState();
      } else {
        this.querySelectorAll(".trigger-update-variant").forEach(function (button) {
          return button.setAttribute("disabled", "true");
        });
        this.updateBuyButtonState();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$querySelector2,
        _this3 = this;
      (_this$querySelector2 = this.querySelector(".atc-btn")) === null || _this$querySelector2 === void 0 ? void 0 : _this$querySelector2.removeEventListener("click", this.addToCartGrid);
      this.querySelectorAll(".trigger-update-variant").forEach(function (el) {
        el.removeEventListener("click", _this3.getVariantBySelectedOption);
      });
    }
  }, {
    key: "updatePriceCurrentVariant",
    value: function updatePriceCurrentVariant() {
      var _this4 = this;
      //update price
      if (this.selectedVariant) {
        var variant = this.product.variants.find(function (variant) {
          return variant.id === _this4.selectedVariant;
        });
        this.priceWrapper.innerHTML = (variant.compare_at_price > variant.price ? "<span class=\"visually-hidden\">Sale price </span>" : "").concat("<span class=\"grid-product__price\" ").concat(variant.compare_at_price > variant.price ? "style=\"color:var(--colorSaleTag);\"" : "", ">").concat(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat), "</span> ").concat(variant.compare_at_price > variant.price ? "<span class=\"visually-hidden\">Original price </span><span class=\"grid-product__price--original\">".concat(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat), "</span><span class=\"grid-product__price--saved\">(Save ").concat(theme.Currency.formatMoney(variant.compare_at_price - variant.price, theme.settings.moneyFormat), ")</span><span class=\"grid-product__price--percentage\">(").concat(Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100), "% Off)</span>") : "");
      }
    }
  }, {
    key: "updateBuyButtonState",
    value: function updateBuyButtonState() {
      var _this5 = this;
      var variant = this.product.variants.find(function (variant) {
        return variant.id === _this5.selectedVariant;
      });
      var atcButton = this.querySelector(".atc-btn");
      var soldOutLabel = this.querySelector(".soldout");
      if (variant && variant.available) {
        atcButton.classList.remove("hide");
        soldOutLabel.classList.add("hide");
      } else {
        atcButton.classList.add("hide");
        soldOutLabel.classList.remove("hide");
      }
    }
  }, {
    key: "addToCartGrid",
    value: function addToCartGrid(qty) {
      var id = this.selectedVariant;
      var q = qty;
      var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + id,
        dataType: "json",
        success: function success(n) {
          var cart = new theme.CartDrawer();
          cart.init();
          cart.open();
        },
        error: function error(n, c) {
          console.log("fail");
        }
      };
      jQuery.ajax(ajax);
    }
  }, {
    key: "getVariantBySelectedOption",
    value: function getVariantBySelectedOption(optionName, optionValue) {
      var _this6 = this;
      var optionIndex = this.productOptions.findIndex(function (option) {
        return option.toLowerCase() === optionName.toLowerCase();
      });
      if (optionIndex === -1) {
        console.error("Option name \"".concat(optionName, "\" not found in product options."));
        return;
      }

      // Get the current options of the selected variant
      var currentOptions = this.product.variants.find(function (variant) {
        return variant.id === _this6.selectedVariant;
      }).options.slice();

      // Update only the selected option value
      currentOptions[optionIndex] = optionValue;

      // Find the variant that matches the updated options
      var selectedVariant = this.product.variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option.toLowerCase() === currentOptions[index].toLowerCase();
        });
      });
      if (selectedVariant) {
        this.selectedVariant = selectedVariant.id;
        this.selectVariantSelectionByOption(selectedVariant.options);
      }

      // i want to update the quantity for the other options
      // Check and update the availability of other options
      this.productOptions.forEach(function (option, index) {
        if (index !== optionIndex) {
          var optionValues = new Set(_this6.product.variants.filter(function (variant) {
            return variant.options[optionIndex].toLowerCase() === optionValue.toLowerCase();
          }).map(function (variant) {
            return variant.options[index].toLowerCase();
          }));
          _this6.querySelectorAll(".trigger-update-variant[data-option-name=\"".concat(option, "\"]")).forEach(function (button) {
            if (optionValues.has(button.dataset.optionValue.toLowerCase())) {
              button.removeAttribute("disabled");
            } else {
              button.setAttribute("disabled", "true");
            }
          });
        }
      });
    }
  }, {
    key: "selectVariantSelectionByOption",
    value: function selectVariantSelectionByOption(optionValues) {
      var _this7 = this;
      this.querySelectorAll(".trigger-update-variant").forEach(function (el) {
        el.classList.remove("selected-btn");
      });
      var buttons = this.querySelectorAll(".trigger-update-variant");
      optionValues.forEach(function (value, index) {
        var buttonsWithValues = Array.from(buttons).filter(function (button) {
          return button.dataset.optionName.toLowerCase() === _this7.productOptions[index].toLowerCase() && button.dataset.optionValue.toLowerCase() === value.toLowerCase();
        });
        buttonsWithValues.forEach(function (button) {
          return button.classList.add("selected-btn");
        });
      });
    }
  }, {
    key: "checkDisablitiyButtons",
    value: function checkDisablitiyButtons(optionName, optionValue) {
      var _this8 = this;
      if (this.productOptions.length === 1) {
        var availableOptions = this.product.variants.filter(function (variant) {
          return variant.available;
        }).map(function (variant) {
          return variant.options[0];
        });
        this.querySelectorAll(".trigger-update-variant[data-option-name=\"".concat(optionName.toLowerCase(), "\"]")).forEach(function (button) {
          if (availableOptions.includes(button.dataset.optionValue)) {
            button.removeAttribute("disabled");
          } else {
            button.setAttribute("disabled", "true");
          }
        });
      } else {
        var selectedOptionIndex = this.productOptions.findIndex(function (option) {
          return option.toLowerCase() === optionName.toLowerCase();
        });
        var selectedOptionValues = this.product.variants.filter(function (variant) {
          return variant.options[selectedOptionIndex].toLowerCase() === optionValue.toLowerCase() && variant.available;
        }).map(function (variant) {
          return variant.options;
        });
        this.productOptions.forEach(function (option, index) {
          if (index !== selectedOptionIndex) {
            var availableValues = new Set(selectedOptionValues.map(function (values) {
              return values[index].toLowerCase();
            }));
            _this8.querySelectorAll(".trigger-update-variant[data-option-name=\"".concat(option.toLowerCase(), "\"]")).forEach(function (button) {
              if (availableValues.has(button.dataset.optionValue.toLowerCase())) {
                button.removeAttribute("disabled");
              } else {
                button.setAttribute("disabled", "true");
              }
              // Update image based on the current options
              var variantImage = Array.from(_this8.variantsImages).find(function (image) {
                var imageOptions = JSON.parse(image.dataset.variantOptions);
                return imageOptions.some(function (option) {
                  return option.toLowerCase() === optionValue.toLowerCase() && imageOptions.map(function (opt) {
                    return opt.toLowerCase();
                  }).includes(button.dataset.optionValue.toLowerCase());
                });
              });
              if (variantImage) {
                button.dataset.variantImage = variantImage.dataset.variantImage;
                button.dataset.variantImageSrcset = variantImage.dataset.variantImageSrcset;
                if (button.dataset.optionName.toLowerCase() === 'color') {
                  button.style.backgroundImage = "url(".concat(variantImage.dataset.variantImage, ")");
                }
              }
            });
          }
        });
      }
    }
  }]);
  return ProductItemCard;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("product-item-card", ProductItemCard);

//product slider
// Define a class for the Swiper component that extends the HTMLElement class
var PrototypeSlider = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(PrototypeSlider, _HTMLElement2);
  var _super2 = _createSuper(PrototypeSlider);
  // The constructor is called when an object is created with the class
  function PrototypeSlider() {
    var _this9;
    _classCallCheck(this, PrototypeSlider);
    _this9 = _super2.call(this); // Call the parent class constructor
    _this9.slideDesktop = _this9.dataset.slideDesktop;
    _this9.slideMobile = _this9.dataset.slideMobile;
    return _this9;
  }

  // connectedCallback is a lifecycle method that is called when the custom element is first connected to the document's DOM
  _createClass(PrototypeSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initSwiper(); // Initialize the Swiper when the component is connected

      // Add event listeners
      document.addEventListener('shopify:section:load', this.initSwiper);
      document.addEventListener('shopify:section:reorder', this.initSwiper);
      document.addEventListener('shopify:section:select', this.initSwiper);
      document.addEventListener('shopify:block:select', this.initSwiper);
    }

    // Method to initialize the Swiper
  }, {
    key: "initSwiper",
    value: function initSwiper() {
      // Define the options for the Swiper
      var calculateSpaceBetween = function calculateSpaceBetween(slidesPerView) {
        if (slidesPerView < 2) return 80;
        if (slidesPerView >= 2 && slidesPerView <= 4) return 60;
        return 40;
      };
      var swiperOptions = {
        slidesPerView: this.slideMobile,
        // Number of slides per view
        spaceBetween: calculateSpaceBetween(this.slideMobile),
        // Space between slides
        breakpoints: {
          // Breakpoints for different screen widths
          768: {
            slidesPerView: this.slideDesktop,
            spaceBetween: calculateSpaceBetween(this.slideDesktop)
          }
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      };

      // Initialize the Swiper with the options
      new Swiper(this, swiperOptions);
    }
  }]);
  return PrototypeSlider;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the custom element
customElements.define("prototype-slider", PrototypeSlider);

// Add variant swatch observer for PDP page
var VariantSwatchObserver = /*#__PURE__*/function () {
  function VariantSwatchObserver() {
    _classCallCheck(this, VariantSwatchObserver);
    this.init();
  }
  _createClass(VariantSwatchObserver, [{
    key: "init",
    value: function init() {
      var _this10 = this;
      // Watch for changes to the DOM to catch when variant swatches are added
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes.length) {
            _this10.setupSwatchListeners();
          }
        });
      });

      // Start observing the document body
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Try to set up listeners immediately in case swatches are already on the page
      this.setupSwatchListeners();
    }
  }, {
    key: "setupSwatchListeners",
    value: function setupSwatchListeners() {
      var _this11 = this;
      // Find all variant-swatch-king elements
      var swatchContainers = document.querySelectorAll('.page-content--product variant-swatch-king');
      if (swatchContainers.length > 0) {
        console.log('Found variant swatch containers:', swatchContainers.length);
        swatchContainers.forEach(function (container) {
          // Find all swatch items within each container
          var swatchItems = container.querySelectorAll('.swatch-view-item');
          swatchItems.forEach(function (item) {
            // Remove existing listeners to avoid duplicates
            item.removeEventListener('click', _this11.handleSwatchClick);
            // Add click event listener
            item.addEventListener('click', _this11.handleSwatchClick);
          });
        });
      }
    }
  }, {
    key: "handleSwatchClick",
    value: function handleSwatchClick(event) {
      var swatchItem = event.currentTarget;
      var backInstockButton = document.querySelector('.klaviyo-bis-trigger');
      if (backInstockButton && swatchItem && swatchItem.classList.contains('swatch-item-unavailable')) {
        // If the swatch is unavailable, show the back in stock button
        backInstockButton.classList.remove('hidden');
      } else {
        // If the swatch is available, hide the back in stock button
        backInstockButton.classList.add('hidden');
      }
    }
  }]);
  return VariantSwatchObserver;
}(); // Initialize the variant swatch observer
document.addEventListener('DOMContentLoaded', function () {
  new VariantSwatchObserver();

  // Initialize free gift calculator if it exists
  if (window.CustomComponents && window.CustomComponents.FreeGiftCalculator) {
    window.CustomComponents.FreeGiftCalculator.init();
  }
});

//quiz capture event listner ATC watcher
document.addEventListener('oke_connect_cart_itemVariantAdded', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          document.dispatchEvent(new CustomEvent('cart:build'));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());

/***/ }),

/***/ "./src/scss/sr-custom.scss":
/*!*********************************!*\
  !*** ./src/scss/sr-custom.scss ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/sr-custom": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgrayl"] = self["webpackChunkgrayl"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/scss/sr-custom.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;